/**
 * @generated SignedSource<<2e48ca742e8318fab3b0bf3b219417f9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartureLocationEditForm_departureLocation$data = {
  readonly codes: ReadonlyArray<string>;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "DepartureLocationEditForm_departureLocation";
};
export type DepartureLocationEditForm_departureLocation$key = {
  readonly " $data"?: DepartureLocationEditForm_departureLocation$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationEditForm_departureLocation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartureLocationEditForm_departureLocation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "codes",
      "storageKey": null
    }
  ],
  "type": "DepartureLocation",
  "abstractKey": null
};

(node as any).hash = "88ad08eb2fecab846fa5d952edb42901";

export default node;
